import { Order } from 'mixs/orders/planner_base';

class OrdersToday extends Order {
  ordersPhase: any = {}
  init(){
    super.init();
    for(let i=0; i<this.opts.phases.length; i++){
      let ordersPhase = this.opts.phases[i];
      if(ordersPhase.id == this.opts.phaseId){
        this.ordersPhase = ordersPhase;
        break;
      }
    }
  }
}
riot.mixin('orders.today', OrdersToday as riot.TagMixin)
